import { AxiosPromise } from "axios";
import api from "../../services/api";
import { Config } from "./@types";
import apiTs from "./api";
import RLAuxiliaryAnalysisLabel from "./components/RLAuxiliaryAnalysisLabel";
import RLCloudSandboxLabel from "./components/RLCloudSandboxLabel";

export const INTEGRATIONS = {
  rl_dynamic_analysis: "rl_dynamic_analysis",
  rl_auxiliary_analysis: "rl_auxiliary_analysis",
  cape: "cape",
  cisco_secure_malware_analytics: "cisco_secure_malware_analytics",
  cuckoo: "cuckoo",
  joe: "joe",
  fireeye: "fireeye",
  vmray_tcbase: "vmray_tcbase"
} as const;

export const INTEGRATION_NAMES = Object.keys(INTEGRATIONS) as Array<
  keyof typeof INTEGRATIONS
>;

export const INTEGRATION_LABELS = {
  [INTEGRATIONS.rl_dynamic_analysis]: RLCloudSandboxLabel,
  [INTEGRATIONS.rl_auxiliary_analysis]: RLAuxiliaryAnalysisLabel,
  [INTEGRATIONS.cape]: "CAPE",
  [INTEGRATIONS.cisco_secure_malware_analytics]:
    "Cisco Secure Malware Analytics",
  [INTEGRATIONS.cuckoo]: "Cuckoo",
  [INTEGRATIONS.joe]: "Joe",
  [INTEGRATIONS.fireeye]: "FireEye",
  [INTEGRATIONS.vmray_tcbase]: "VMRay"
} as const;

export type IntegrationLabelsKey = keyof typeof INTEGRATION_LABELS;

export const INTEGRATION_LABELS_TEXT = {
  [INTEGRATIONS.rl_dynamic_analysis]: "RL Cloud Sandbox",
  [INTEGRATIONS.rl_auxiliary_analysis]: "RL Auxiliary Analysis",
  [INTEGRATIONS.cape]: INTEGRATION_LABELS[INTEGRATIONS.cape],
  [INTEGRATIONS.cisco_secure_malware_analytics]:
    INTEGRATION_LABELS[INTEGRATIONS.cisco_secure_malware_analytics],
  [INTEGRATIONS.cuckoo]: INTEGRATION_LABELS[INTEGRATIONS.cuckoo],
  [INTEGRATIONS.joe]: INTEGRATION_LABELS[INTEGRATIONS.joe],
  [INTEGRATIONS.fireeye]: INTEGRATION_LABELS[INTEGRATIONS.fireeye],
  [INTEGRATIONS.vmray_tcbase]: INTEGRATION_LABELS[INTEGRATIONS.vmray_tcbase]
} as const;

type TestConnectionFn = () => AxiosPromise<Config.TestConnectionResponse>;

export const TEST_CONNECTION_MAP: Record<string, TestConnectionFn> = {
  [INTEGRATIONS.cape]: api.testCapeConnection,
  [INTEGRATIONS.cisco_secure_malware_analytics]:
    apiTs.testCiscoSecureMalwareAnalyticsConnection,
  [INTEGRATIONS.cuckoo]: api.testCuckooConnection,
  [INTEGRATIONS.fireeye]: api.testFireEyeConnection,
  [INTEGRATIONS.joe]: api.testJoeConnection,
  [INTEGRATIONS.vmray_tcbase]: api.testVmRayConnection
} as const;

export const UPDATE_CONFIG_MAP = {
  [INTEGRATIONS.cape]: api.updateCapeConfig,
  [INTEGRATIONS.cisco_secure_malware_analytics]:
    apiTs.updateCiscoSecureMalwareAnalyticsConfig,
  [INTEGRATIONS.cuckoo]: api.updateCuckooConfig,
  [INTEGRATIONS.joe]: api.updateJoeConfig,
  [INTEGRATIONS.fireeye]: api.updateFireEyeConfig,
  [INTEGRATIONS.vmray_tcbase]: api.updateVmRayConfig
} as const;
